import React from 'react';
import PropTypes from 'prop-types';
import ReactTimeAgo from 'react-time-ago/no-tooltip';
import { DateTime } from 'luxon';
import { LUXTON_FORMAT_DATE_TIME } from '../helpers/date';

const DateTimeDisplay = ({
  value = '',
  label = '',
  separator = ' - ',
  withAlert = false,
  hideIfInvalid = false,
  dateFormat
}) => {
  let date;
  if (dateFormat) {
    date = DateTime.fromFormat(value, dateFormat);
  } else {
    date = DateTime.fromISO(value);
  }
  const isValidDate = date.isValid;
  let content;
  if (isValidDate) {
    content = (
      <span className="">
        {label} {date.toFormat(LUXTON_FORMAT_DATE_TIME)} {separator}
        <ReactTimeAgo locale="en-US">{date.toJSDate()}</ReactTimeAgo>
      </span>
    );
  } else {
    if (hideIfInvalid) {
      return <span />;
    } else {
      content = <span>Invalid date {value}</span>;
    }
  }
  if (withAlert) {
    return <div className="alert alert-info">{content}</div>;
  }
  return <span>{content}</span>;
};

DateTimeDisplay.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  withAlert: PropTypes.bool,
  hideIfInvalid: PropTypes.bool,
  label: PropTypes.string,
  separator: PropTypes.string,
  dateFormat: PropTypes.string
};

export default DateTimeDisplay;



// WEBPACK FOOTER //
// ./src/components/DateTimeDisplay.js